import React, { useState } from 'react';
import { Flex, Input, Label } from 'pcln-design-system';
import { DASH_INDEX, LAST_SPACE_INDEX, MAX_NUMBER_LENGTH, PHONE_FORMAT, PREFIX_LENGTH, RIGHT_BRACKET_INDEX } from './constants/PhoneNumberFormat';
/** @public */
const PhoneInput = ({
  label,
  onChange,
  ...props
}) => {
  const [inputValue, setInputValue] = useState('');
  const isValidFormat = phoneNumber => {
    for (let index = 0; index < phoneNumber.length; index++) {
      const char = phoneNumber[index];
      const hasIndex = PHONE_FORMAT[index];
      if (hasIndex && PHONE_FORMAT[index] !== char || !hasIndex && isNaN(parseInt(char))) {
        return false;
      }
    }
    return true;
  };
  const isValidPhoneNumber = phoneNumber => {
    return isValidFormat(phoneNumber) && phoneNumber.length === MAX_NUMBER_LENGTH;
  };
  const updateInputWithFormat = value => {
    const length = value.length;
    const isInputBeingDeleted = value.length < inputValue.length;
    if (length < PREFIX_LENGTH) {
      if (isInputBeingDeleted) {
        return setInputValue('');
      } else {
        const valueWithFormat = `+1 (${value}`;
        if (isValidFormat(valueWithFormat)) {
          setInputValue(valueWithFormat);
        }
        return;
      }
    }
    if (!isValidFormat(value)) {
      return;
    }
    if (length === RIGHT_BRACKET_INDEX && !isInputBeingDeleted) {
      return setInputValue(`${value}) `);
    }
    if (length === LAST_SPACE_INDEX && isInputBeingDeleted) {
      return setInputValue(value.substring(0, LAST_SPACE_INDEX - 2));
    }
    if (length === DASH_INDEX) {
      return isInputBeingDeleted ? setInputValue(value.substring(0, DASH_INDEX - 1)) : setInputValue(`${value}-`);
    }
    if (length > MAX_NUMBER_LENGTH && !isInputBeingDeleted) {
      return;
    }
    setInputValue(value);
    onChange(isValidPhoneNumber(value), value);
  };
  function handleChange(e) {
    updateInputWithFormat(e.target.value);
  }
  return React.createElement(Flex, {
    flexDirection: 'column',
    ...props
  }, label && React.createElement(Label, {
    "data-testid": 'input-label',
    mb: 2
  }, label), React.createElement(Flex, {
    color: 'background.lightest',
    borderRadius: 'xl'
  }, React.createElement(Input, {
    "data-testid": 'form-input',
    id: 'form-input',
    borderRadius: 'xl',
    value: inputValue,
    size: 'lg',
    placeholder: '+1 (204) 867-5309',
    onChange: handleChange
  })));
};
export default PhoneInput;